/* ============================================================
   de+h wellness — GA4 custom event tracking
   ------------------------------------------------------------
   Tailored to THIS theme (verified against the real DOM, not guessed):
     • #testimonials / #how-it-works  — confirmed real section IDs
     • image zoom  — image_zoom = "lightbox" → Dawn's .product__media-toggle
     • chat        — Flyweight AI chatbot app-embed (config/settings_data.json)
     • subscribe   — Joy subscription app injects a [name="selling_plan"] field

   Loaded from layout/theme.liquid (deferred). Relies on gtag() being present,
   which the Google & YouTube app provides on the live storefront. If gtag isn't
   there yet, this no-ops silently.

   Test: add ?debug_mode=true to any URL, then watch GA4 > Admin > DebugView.
   Then in GA4 > Admin > Events, mark `select_purchase_type` as a key event.
   ============================================================ */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    if (typeof gtag !== 'function') {
      console.warn('[deth-analytics] gtag() not found — custom tracking skipped');
      return;
    }

    /* 1. SUBSCRIBE vs ONE-TIME ------------------------------------------------
       The single most valuable event for a supplement brand (LTV driver).
       Read selling_plan straight off the add-to-cart form at submit time. The
       capture-phase listener runs BEFORE Dawn's AJAX handler preventDefaults,
       and fires exactly once per add — so no window.fetch override and no
       double-counting (the original script did both a submit listener AND a
       fetch patch, which double-fires on Dawn's AJAX cart). */
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;

        var isSub = false;
        var checkedRadio = form.querySelector('input[name="selling_plan"]:checked');
        if (checkedRadio) {
          isSub = !!checkedRadio.value; // one-time radio carries an empty value
        } else {
          var field = form.querySelector('select[name="selling_plan"], input[name="selling_plan"]:not([type="radio"])');
          isSub = !!(field && field.value);
        }

        gtag('event', 'select_purchase_type', {
          purchase_type: isSub ? 'subscription' : 'one_time',
        });
      },
      true
    );

    /* 2 & 3. SECTION ENGAGEMENT ----------------------------------------------
       Fire once when a key section scrolls into view. Both IDs confirmed real
       in this theme (sections/deth-testimonials.liquid, deth-how-it-works.liquid). */
    function trackSectionView(id, eventName) {
      var el = document.getElementById(id);
      if (!el || !('IntersectionObserver' in window)) return;
      var obs = new IntersectionObserver(
        function (entries) {
          if (entries[0].isIntersecting) {
            gtag('event', eventName);
            obs.disconnect();
          }
        },
        { threshold: 0.5 }
      );
      obs.observe(el);
    }
    trackSectionView('testimonials', 'testimonials_viewed');
    trackSectionView('how-it-works', 'how_it_works_viewed');

    /* 4. PRODUCT IMAGE ZOOM ---------------------------------------------------
       image_zoom is "lightbox": Dawn overlays a .product__media-toggle button
       that opens the media modal — that's the exact, real click target. */
    document.body.addEventListener('click', function (e) {
      if (e.target.closest('.product__media-toggle')) {
        gtag('event', 'product_image_zoom');
      }
    });

    /* 5. CHAT OPENED ----------------------------------------------------------
       Chat is the Flyweight AI chatbot app-embed — NOT one of the iframe
       vendors the generic watcher looked for, so track the entry points we
       actually control: the "nyra" footer video and the chat button. The nyra
       video also programmatically clicks the real chat button, which bubbles
       back here — the timestamp guard dedupes that so one open = one event. */
    var lastChatFire = 0;
    document.body.addEventListener('click', function (e) {
      if (
        !e.target.closest(
          '.deth-video-loop__video, #chat-button, .chat-button, [data-testid="chat-button"]'
        )
      ) {
        return;
      }
      var now = Date.now();
      if (now - lastChatFire < 1000) return;
      lastChatFire = now;
      gtag('event', 'chat_widget_opened');
    });

    /* 6. CROSS-SELL ("You may also like") CLICK-THROUGH -----------------------
       Related-product cards have no quick-add in this theme — they link to the
       PDP — so the meaningful signal is WHICH recommended product gets clicked.
       Fires GA4's recommended `select_item` with the list name, so it lands in
       GA4's item-list reports and you can tell whether the module drives real
       navigation (and pair it with downstream purchases). */
    document.body.addEventListener('click', function (e) {
      var link = e.target.closest('.related-products a[href]');
      if (!link) return;
      var card = link.closest('.card-wrapper, .grid__item') || link;
      var nameEl = card.querySelector('.card__heading a, .full-unstyled-link') || link;
      gtag('event', 'select_item', {
        item_list_name: 'You may also like',
        items: [{ item_name: (nameEl.textContent || '').trim() }],
      });
    });

    /* 7. CHECKOUT INTENT ------------------------------------------------------
       cart_type is "notification" (no drawer), so the checkout button lives in
       the add-to-cart notification popup AND on the /cart page — both use
       name="checkout". Track the click as a funnel step that happens BEFORE
       Shopify's own auto `begin_checkout` (which fires on the checkout page).
       Distinct event name so the two never double-count; the gap between this
       and begin_checkout is your notification -> checkout drop-off. */
    document.body.addEventListener('click', function (e) {
      if (e.target.closest('button[name="checkout"], [name="checkout"]')) {
        gtag('event', 'checkout_click');
      }
    });
  });
})();
